unable to read source [project]/packages/core/src/devtools/getSourceURLfromError.ts